import type { CropVarietyConfigurationsByKey } from "../types.js";

const GRAPE_COLORS = {
    WHITE: "#debe6c",
    BLACK: "#594e75",
    PINK: "#ec89d5",
    BLUE: "#3a519f",
    RED: "#9b3e39",
} as const;

export const grapeVarietyConfigurations = {
    "grape.abrusco": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.adreuli-skelkana": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.affenthaler": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ag-aldere": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ag-kurdashi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.agiorgitiko": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.aglianico": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.airen": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.akhmetis-tsiteli": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.albarino": {
        crop: "grape",
        aliases: ["Alvarinho"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.albarossa": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.albillo-mayor": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.albillo-real": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.alden": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.aleatico": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.alexandrouli": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.alfrocheiro": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ali-shaitan": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.alicante-bouschet": {
        crop: "grape",
        aliases: ["Garnacha Tintorera", "Alicante"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.aligote": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.allison": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.almeria": {
        crop: "grape",
        aliases: ["Ohanez"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.alvarelhao": {
        crop: "grape",
        aliases: ["Brancellao"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ambulo-blanc": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ansonica": {
        crop: "grape",
        aliases: ["Inzolia", "Insolia"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.apple-grape": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.arabeuli-shavi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.aramon": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.arandell": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.arinarnoa": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.arinto": {
        crop: "grape",
        aliases: ["Pedernã"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.arneis": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.arnsburger": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.aromella": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.arvine": {
        crop: "grape",
        aliases: ["Petite Arvine"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.asgari": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.askeri": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.assyrtiko": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.athiri": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.aurore": {
        crop: "grape",
        aliases: ["Seibel 5279"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.autumn-black": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.autumn-crisp": {
        crop: "grape",
        aliases: ["Sugrathirtyfive"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.autumn-king": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.autumn-royal": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.autumn-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.auxerrois": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.avgoustiatis": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.babic": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.babica": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bacchus": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.baco-blanc": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.baco-noir": {
        crop: "grape",
        aliases: ["Baco 1"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.barbaroux": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.barbera": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.barlinka": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bazaleturi-tsolikouri": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.beauty-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.beclan": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bez-el-anza": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.biancolella": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.biancu-gentile": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bidaneh": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bien-donne": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.big-pete": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.black-beet": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.black-corinth": {
        crop: "grape",
        aliases: ["Zante Currant", "Champagne Grape"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.black-emerald": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.black-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.black-spanish": {
        crop: "grape",
        aliases: ["Lenoir", "Jacquez", "Jacquet"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.blackrose": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.blanc-du-bois": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.blauer-portugieser": {
        crop: "grape",
        aliases: ["Portugieser"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bluebell": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLUE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.blush-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bolgar": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bon-noir": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bonarda": {
        crop: "grape",
        aliases: ["Bonarda"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bourboulenc": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.brachetto": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.brianna": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bronx-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.brs-vitoria": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.bruces-sport": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.budeshuri-tsiteli": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.burger": {
        crop: "grape",
        aliases: ["Monbadon"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.burgrave": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cabernet-dorsa": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cabernet-franc": {
        crop: "grape",
        aliases: ["Bouchet", "Breton", "Cab Franc"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cabernet-sauvignon": {
        crop: "grape",
        aliases: ["Cab", "Cab Sauv"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: ["7", "8", "15", "169", "337", "412"],
    },
    "grape.cabernet-volos": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.caladoc": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.calmeria": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.calzin": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.caminante-blanc": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.camminare-noir": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.canner": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.caprettone": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cardinal": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.carignane": {
        crop: "grape",
        aliases: ["Carignan", "Cariñena", "Mazuelo", "Mazuela", "Samsó", "Carignano"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.carina": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.carlos": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.carmenere": {
        crop: "grape",
        aliases: ["Grande Vidure"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.carmine": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.carnelian": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.casculho": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.casetta": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.castela": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.castelao": {
        crop: "grape",
        aliases: ["Periquita", "João de Santarém"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.castets": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.catarratto": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.catawba": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cayuga-white": {
        crop: "grape",
        aliases: ["Cayuga"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.centennial-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.centurion": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cereza": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.chambourcin": {
        crop: "grape",
        aliases: ["Joannès Seyve 26-205"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.champanel": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.chancellor": {
        crop: "grape",
        aliases: ["Seibel 7053"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.charbono": {
        crop: "grape",
        aliases: ["Douce Noir", "Corbeau", "Bonarda", "Bonarda Argentina"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.chardonel": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.chardonnay": {
        crop: "grape",
        aliases: ["Chard", "Morillon"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: ["4", "76", "95", "96", "124", "548", "Wente"],
    },
    "grape.chardonnay-4x": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.chasselas-dore": {
        crop: "grape",
        aliases: ["Chasselas", "Fendant", "Gutedel"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.chelois": {
        crop: "grape",
        aliases: ["Seibel 10878"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.chenin-blanc": {
        crop: "grape",
        aliases: ["Steen", "Pineau de la Loire", "Chenin"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cherta": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.chimenti-globe": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.christmas-rose": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ciliegiolo": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cinsaut": {
        crop: "grape",
        aliases: ["Cinsault", "Hermitage", "Black Malvoisie"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.clairette-blanche": {
        crop: "grape",
        aliases: ["Clairette"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.colombard": {
        crop: "grape",
        aliases: ["French Colombard"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.concieira": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.concord": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.concord-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cornifesto": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.corot-noir": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cortese": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.corvina-veronese": {
        crop: "grape",
        aliases: ["Corvina"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cotton-candy": {
        crop: "grape",
        aliases: ["IFG Seven"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.couderc-241-123": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.counoise": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.courbu-blanc": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.crimson-pearl": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.crimson-seedless": {
        crop: "grape",
        aliases: ["Crimson"],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.criolla-grande": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.croatina": {
        crop: "grape",
        aliases: ["Bonarda"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.cserszegi-fuszeres": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.danakharuli": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dattier": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dattier-de-st-vallier": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dawn-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.debit": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dechaunac": {
        crop: "grape",
        aliases: ["Seibel 9549"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.delaware": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.delight": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.diamond": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.diamond-muscat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dimyat": {
        crop: "grape",
        aliases: ["Dimiat"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dizmar": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dolcetto": {
        crop: "grape",
        aliases: ["Ormeasco"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dondghlabi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.donzillinho": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.doradillo": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dornfelder": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dovine": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dunkelfelder": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dunstan-2": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.durif": {
        crop: "grape",
        aliases: ["Petite Sirah", "Petite Syrah"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.dutchess": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.early-burgundy": {
        crop: "grape",
        aliases: ["Abouriou"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.early-muscat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.early-sweet": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.edelweiss": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ederena": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ehrenfelser": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.elbling": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.elvira": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.emerald-riesling": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.emerald-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.emir": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.emperor": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.erbaluce": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.errante-noir": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.esparte": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.etoile-i": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.excelsior-guilly": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.exotic": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.falanghina": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fantasy-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fay-rouge": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.feher-szagos": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fer": {
        crop: "grape",
        aliases: ["Fer Servadou", "Mansois"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ferdinand-de-lesseps": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fernao-pires": {
        crop: "grape",
        aliases: ["Maria Gomes"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.feteasca-alba": {
        crop: "grape",
        aliases: ["Leányka"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fiano": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fiesta": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fileri": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.flame-seedless": {
        crop: "grape",
        aliases: ["Flame"],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.flame-tokay": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.flora": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fokiano": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.folle-blanche": {
        crop: "grape",
        aliases: ["Gros Plant"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.forastera": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fredonia": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.freisa": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.frontenac": {
        crop: "grape",
        aliases: ["MN 1047"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.frontenac-blanc": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.frontenac-gris": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.fujiminori": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.furmint": {
        crop: "grape",
        aliases: ["Šipon"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gamaret": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gamay-noir": {
        crop: "grape",
        aliases: ["Gamay", "Gamay Noir à Jus Blanc"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.garanoir": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.garganega": {
        crop: "grape",
        aliases: ["Grecanico"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.garnacha-gris": {
        crop: "grape",
        aliases: ["Grenache Gris"],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.garnacha-peluda": {
        crop: "grape",
        aliases: ["Lledoner Pelut"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.garonnet": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gasconade": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gechi-kyrlen": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.geneva-red": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gewurztraminer": {
        crop: "grape",
        aliases: ["Gewurz", "Traminer Aromatico"],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.glavinusa": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.glennel": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.godello": {
        crop: "grape",
        aliases: ["Gouveio"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gold": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gold-finger": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gorby": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.goron-de-bovernier": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gouais-blanc": {
        crop: "grape",
        aliases: ["Heunisch"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.goyura": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.graciano": {
        crop: "grape",
        aliases: ["Tinta Miúda", "Cagnulari", "Morrastel"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.grand-noir": {
        crop: "grape",
        aliases: ["Grand Noir de la Calmette"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.greco-di-tufo": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.green-hungarian": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.grenache-blanc": {
        crop: "grape",
        aliases: ["Garnacha Blanca", "Garnatxa Blanca"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.grenache-noir": {
        crop: "grape",
        aliases: ["Grenache", "Garnacha", "Garnacha Tinta", "Cannonau", "Garnatxa", "Alicante"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.grignolino": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.grillo": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gros-manseng": {
        crop: "grape",
        aliases: ["Manseng"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gruner-veltliner": {
        crop: "grape",
        aliases: ["Grüner"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.gulabi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.harslevelu": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.helena": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.herbemont": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.himrod": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.hungarian-riesling": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.hunisa": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.husseine": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.isabella": {
        crop: "grape",
        aliases: ["Isabel", "Fragola", "Uva Fragola"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: ["Isabel Precoce"],
    },
    "grape.italia": {
        crop: "grape",
        aliases: ["Pirovano 65"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: ["Benitaka", "Brasil", "Rubi"],
    },
    "grape.itchkimar": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ives": {
        crop: "grape",
        aliases: ["Bordô", "Ives Noir"],
        color: GRAPE_COLORS.BLUE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ivory": {
        crop: "grape",
        aliases: ["Sheegene 21"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.jacks-salute": {
        crop: "grape",
        aliases: ["IFG Nine"],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.juan-garcia": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.july-muscat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kadarka": {
        crop: "grape",
        aliases: ["Gamza"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kakhet": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kamenina": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kandhara": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kartlis-tita": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kerner": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.khatun-khardzhi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.khindogni": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kidonitsa": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.king-of-the-north": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kishmish-vatkana": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kizil-sapak": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.korona": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.koshu": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kozma-55": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.krissy": {
        crop: "grape",
        aliases: ["Sheegene 12"],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.kyoho": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.la-crescent": {
        crop: "grape",
        aliases: ["MN 1166"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.lacrima-di-morro-dalba": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.lagorthi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.lagrein": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.lambrusca-di-alessandria": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.landot-noir": {
        crop: "grape",
        aliases: ["Landot 4511"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.laurot": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.leon-milot": {
        crop: "grape",
        aliases: ["Léon Millot", "Kuhlmann 194-2"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.limberger": {
        crop: "grape",
        aliases: ["Blaufränkisch", "Lemberger", "Kékfrankos", "Frankovka"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.limnio": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.limniona": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ln33": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.lomanto": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.loose-perlette": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.louise-swenson": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.loureiro": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.macabeo": {
        crop: "grape",
        aliases: ["Viura", "Macabeu"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.madeleine-angevine": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.magenta": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.malaga": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.malagouzia": {
        crop: "grape",
        aliases: ["Malagousia"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.malbec": {
        crop: "grape",
        aliases: ["Cot", "Pressac"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.malvasia-bianca": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.malvasia-dubrovacka": {
        crop: "grape",
        aliases: ["Malvasia di Lipari", "Malvasia di Sardegna"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.malvasia-fina": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.malvasia-istriana": {
        crop: "grape",
        aliases: ["Malvazija Istarska"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.malvasia-preta": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.manseng": {
        crop: "grape",
        aliases: ["Manseng"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mantuo-de-pilas": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.marechal-foch": {
        crop: "grape",
        aliases: ["Foch", "Kuhlmann 188-2"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.marquette": {
        crop: "grape",
        aliases: ["MN 1211"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.marquis": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mars": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.marsanne": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.marselan": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.marufo": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.marzemino": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mavrodaphne": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mavron": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.maxine-rouge": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mehdi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.melissa": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.melody": {
        crop: "grape",
        aliases: ["Blagratwo"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.melon": {
        crop: "grape",
        aliases: ["Melon de Bourgogne", "Muscadet"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mencia": {
        crop: "grape",
        aliases: ["Jaen"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.merlot": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: ["3", "181", "314"],
    },
    "grape.merlot-kanthus": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.midnight-beauty": {
        crop: "grape",
        aliases: ["Sugrathirteen"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.misket-black": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.misket-plevenski": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.missblanc": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mission": {
        crop: "grape",
        aliases: ["País", "Listán Prieto", "Criolla Chica", "Misión", "Negra Corriente", "Negra Criolla"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.molinara": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.molinera": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mollard": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mondeuse": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.montepulciano": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.monukka": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.morenillo": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.moreto": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mortensen-hardy": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.moscato-giallo": {
        crop: "grape",
        aliases: ["Goldmuskateller"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.moschofilero": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mourisco-de-semente": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mourtaou": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.mourvedre": {
        crop: "grape",
        aliases: ["Monastrell", "Mataro", "Morrastel"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.muller-thurgau": {
        crop: "grape",
        aliases: ["Rivaner"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.muscadelle": {
        crop: "grape",
        aliases: ["Muscadelle du Bordelais", "Sauvignon Vert"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.muscardin": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.muscat-blanc": {
        crop: "grape",
        aliases: [
            "Muscat Blanc à Petits Grains",
            "Moscato Bianco",
            "Muscat Canelli",
            "Muscat Frontignan",
            "Muskateller",
            "Moscatel de Grano Menudo",
            "Moscatel Galego Branco",
        ],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.muscat-hamburg": {
        crop: "grape",
        aliases: ["Black Muscat", "Moscato d’Amburgo", "Black Hamburg", "Moscatel de Hamburgo", "Muscat de Hambourg"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.muscat-of-alexandria": {
        crop: "grape",
        aliases: [
            "Moscatel de Alejandría",
            "Zibibbo",
            "Hanepoot",
            "Muscat Gordo Blanco",
            "Moscatel Romano",
            "Moscatel de Alexandria",
            "Moscatel de Setúbal",
            "Moscatel de Málaga",
            "Muscat d’Alexandrie",
            "Lexia",
        ],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.muscat-ottonel": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.muscat-st-vallier": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.muxtari": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.nagano-purple": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.nail": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.nakachevanin-gara-kishmishi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.nakachevanin-sahibi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.nascetta": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.nebbiolo": {
        crop: "grape",
        aliases: ["Spanna", "Chiavennasca"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.negrette": {
        crop: "grape",
        aliases: ["Pinot St. George"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.negro-amaro": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.nehelescol": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.nero-davola": {
        crop: "grape",
        aliases: ["Calabrese"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.new-york-muscat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.niabell": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.niagara": {
        crop: "grape",
        aliases: ["Niagara Branca"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: ["Niagara Rosada"],
    },
    "grape.noble": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.noiret": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.norton": {
        crop: "grape",
        aliases: ["Cynthiana"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.odem": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ojaleshi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ontario": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.orange-muscat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.oraniensteiner": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.orion": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ortega": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.palomino": {
        crop: "grape",
        aliases: ["Palomino Fino", "Listán Blanco", "Golden Chasselas"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.parellada": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.paseante-noir": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pedro-gimenez": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pedro-ximenez": {
        crop: "grape",
        aliases: ["PX"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pelaverga": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.peloursin": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.perera": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.perlette": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.persan": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.petit-bouschet": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.petit-manseng": {
        crop: "grape",
        aliases: ["Manseng"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.petit-verdot": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.peverella": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.phoenix": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.picardan": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.picolit": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.picpoul-blanc": {
        crop: "grape",
        aliases: ["Piquepoul Blanc", "Picpoul"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.piedirosso": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pierce": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pignolo": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pinot-blanc": {
        crop: "grape",
        aliases: ["Pinot Bianco", "Weissburgunder"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pinot-gris": {
        crop: "grape",
        aliases: ["Pinot Grigio", "Grauburgunder", "Ruländer"],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pinot-meunier": {
        crop: "grape",
        aliases: ["Meunier", "Schwarzriesling", "Müllerrebe"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pinot-noir": {
        crop: "grape",
        aliases: ["Spätburgunder", "Pinot Nero", "Blauburgunder", "Gamay Beaujolais"],
        color: GRAPE_COLORS.BLACK,
        isExample: true,
        customName: false,
        knownClonalSelections: ["113", "114", "115", "667", "777", "828", "Pommard", "Wädenswil"],
    },
    "grape.pinot-noir-precoce": {
        crop: "grape",
        aliases: ["Frühburgunder"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pinotage": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pione": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pishik-uzumu": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.pixie": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.plavac-mali": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.plavina": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.posip-bijeli": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.prieto-picudo": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.prime": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.princess": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.quebranta": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.queen": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.raboso-piave": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ramming-c51-63": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rauschling": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.red-veltliner": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.redglobe": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.refosco": {
        crop: "grape",
        aliases: ["Refosco dal Peduncolo Rosso"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.regent": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ribier": {
        crop: "grape",
        aliases: ["Alphonse Lavallée"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ribolla-gialla": {
        crop: "grape",
        aliases: ["Rebula"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.riesling": {
        crop: "grape",
        aliases: ["Riesling Renano", "White Riesling", "Johannisberg Riesling", "Rheinriesling"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.riesling-italico": {
        crop: "grape",
        aliases: ["Welschriesling", "Graševina", "Laški Rizling", "Olaszrizling"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rkatsiteli": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.roditis": {
        crop: "grape",
        aliases: ["Rhoditis"],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.romulus": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rondinella": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rossese": {
        crop: "grape",
        aliases: ["Tibouren"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rossese-bianco": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rossiola": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rotberger": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rotgipfler": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rougett": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.roussanne": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.royalty": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rubin-tairovskii": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rubired": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ruby-cabernet": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ruby-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ruche": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rufete": {
        crop: "grape",
        aliases: ["Tinta Pinheira"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.rukatac": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.russian-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sabal-kanskoi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sable-seedless": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sagrantino": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.saint-macaire": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.salvador": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.san-marco": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sangiovese": {
        crop: "grape",
        aliases: ["Nielluccio", "Brunello", "Morellino", "Prugnolo Gentile", "Sangioveto"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sansigot": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.saperavi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.saperavi-budeshuriseburi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sauvignon-blanc": {
        crop: "grape",
        aliases: ["Fumé Blanc", "Blanc Fumé", "Sauv Blanc", "Muskat-Silvaner"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: ["1", "376", "530", "Musqué"],
    },
    "grape.sauvignon-gris": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sauvignon-kretos": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sauvignon-rytos": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.savagnin-blanc": {
        crop: "grape",
        aliases: ["Heida", "Païen", "Traminer", "Savagnin", "Naturé"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.savatiano": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.scarlet": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.scarlet-royal": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.scarlotta-seedless": {
        crop: "grape",
        aliases: ["Sugranineteen"],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.schiava-grossa": {
        crop: "grape",
        aliases: ["Trollinger", "Vernatsch", "Black Hamburg"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.schioppettino": {
        crop: "grape",
        aliases: ["Ribolla Nera"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.schonburger": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.schuyler": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLUE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.seedless-tokay": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.segalin": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.selma-pete": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.semebat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.semillon": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.seneca": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.seyval-blanc": {
        crop: "grape",
        aliases: ["Seyval", "Seyve-Villard 5-276"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.shine-muscat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.siegerrebe": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sklava": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.skrlet": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.slankamenka": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.souzao": {
        crop: "grape",
        aliases: ["Sousão", "Vinhão"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sovereign-opal": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.st-croix": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.st-laurent": {
        crop: "grape",
        aliases: ["Sankt Laurent", "Saint Laurent"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.st-pepin": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.steuben": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.suavis": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sultana-moscata": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.summer-muscat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.summer-royal": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sunbelt": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.superior-seedless": {
        crop: "grape",
        aliases: ["Sugraone", "Superior"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sweet-celebration": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sweet-globe": {
        crop: "grape",
        aliases: ["IFG Ten"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sweet-jubilee": {
        crop: "grape",
        aliases: ["IFG Five"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sweet-sapphire": {
        crop: "grape",
        aliases: ["IFG Six"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sweet-scarlet": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.swenson-red": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.sylvaner": {
        crop: "grape",
        aliases: ["Silvaner"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.symphony": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.syrah": {
        crop: "grape",
        aliases: ["Shiraz"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: ["99", "174", "383", "470", "877"],
    },
    "grape.talibi": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.taminga": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tamnara": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tannat": {
        crop: "grape",
        aliases: ["Harriague"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tarrango": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tauberschwarz": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tempranillo": {
        crop: "grape",
        aliases: [
            "Tinta Roriz",
            "Aragonez",
            "Valdepeñas",
            "Tinto Fino",
            "Tinta del País",
            "Cencibel",
            "Ull de Llebre",
            "Tinta de Toro",
        ],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tempranillo-blanco": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.teroldego": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.terret-noir": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.thiakon": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.thomcord": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.thompson-seedless": {
        crop: "grape",
        aliases: ["Sultanina", "Sultana", "Thompson"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.thomuscat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.timco": {
        crop: "grape",
        aliases: ["Sheegene 13"],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.timorasso": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tinta-bairrada": {
        crop: "grape",
        aliases: ["Baga"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tinta-barroca": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tinta-caiada": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tinta-carvalha": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tinta-francisca": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tinta-madeira": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tinto-cao": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tinto-sem-nome": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tocai-friulano": {
        crop: "grape",
        aliases: ["Friulano", "Sauvignonasse", "Sauvignon Vert", "Tocai"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.torrontes-riojano": {
        crop: "grape",
        aliases: ["Torrontés"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.touriga-brasileira": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.touriga-franca": {
        crop: "grape",
        aliases: ["Touriga Francesa"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.touriga-nacional": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.traminette": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.trentina": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.trincadeira": {
        crop: "grape",
        aliases: ["Tinta Amarela", "Tinta Amarella"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-181-7a": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-30-47": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-blanc": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-f1-16": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-f3-3": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-f3-5": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-t182-4": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-t194-1": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-t213-19": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-t61-13": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.triplett-t793-1": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.trousseau": {
        crop: "grape",
        aliases: ["Bastardo", "Merenzao"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.trousseau-gris": {
        crop: "grape",
        aliases: ["Grey Riesling"],
        color: GRAPE_COLORS.PINK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.tulillah": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.ugni-blanc": {
        crop: "grape",
        aliases: ["Trebbiano Toscano", "Saint Émilion", "Thalia", "Trebbiano"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vaccarese": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.valdiguie": {
        crop: "grape",
        aliases: ["Napa Gamay"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.valley-pearl": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.valvin-muscat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.varousset": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.verdejo": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.verdelho": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.verdicchio": {
        crop: "grape",
        aliases: ["Trebbiano di Soave", "Trebbiano di Lugana"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vermentino": {
        crop: "grape",
        aliases: ["Rolle", "Pigato", "Favorita"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vernaccia-nera": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.verona": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vertzami": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vespaiola": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vespolina": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.victoria-red": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.RED,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vidal-blanc": {
        crop: "grape",
        aliases: ["Vidal", "Vidal 256"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vidiano": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vignoles": {
        crop: "grape",
        aliases: ["Ravat 51"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.villard-blanc": {
        crop: "grape",
        aliases: ["Seyve-Villard 12-375"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vintinto": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.viognier": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.viosinho": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.voskeat": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vranac": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.vugava": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.xarel-lo": {
        crop: "grape",
        aliases: ["Pansa Blanca"],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.xinomavro": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.xynisteri": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.zalema": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.zalxa": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.zeini": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.zinfandel": {
        crop: "grape",
        aliases: ["Primitivo", "Crljenak Kaštelanski", "Tribidrag", "Zin"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.zlahtina": {
        crop: "grape",
        aliases: [],
        color: GRAPE_COLORS.WHITE,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.zweigelt": {
        crop: "grape",
        aliases: ["Blauer Zweigelt", "Rotburger"],
        color: GRAPE_COLORS.BLACK,
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "grape.custom": { crop: "grape", aliases: [], isExample: false, customName: true, knownClonalSelections: [] },
} as const satisfies CropVarietyConfigurationsByKey;
